import Vue from 'vue';

// 高德地图
import VueAMap from 'vue-amap';
Vue.use(VueAMap);

let initMapKeys = '';
Vue.prototype.setMapInit = function(keys, securityJsCode) {
  if (this.$projectType == 4) {
    keys = '965721152949af76d6922a86b187d090';
    securityJsCode = 'cb096c7949e6f77d1a2b975d31d27f63';
  } else if (this.$projectType == 3) {
    keys = '8ae0cd81b8bcb808acc79519e481596d';
    securityJsCode = '4d4840a0a9bfe6fbdec8d259909b3aca';
  } else if (!keys) {
    keys = '9ad8c75a8f39dd87c5985a64fcbba337';
    securityJsCode = '3427d3a10665c39983ee0c78460d2738';
  }
  if (keys != initMapKeys) {
    initMapKeys = keys;
    VueAMap.initAMapApiLoader({
      key: keys,
      plugin: ['Geocoder', 'PoiPicker', 'AMap.PolyEditor', 'Geolocation', 'AMap.MouseTool', 'AMap.GeometryUtil',
        'AMap.Driving', 'AMap.MoveAnimation'
      ],
      uiVersion: '1.0', // ui库版本，不配置不加载,
      v: '1.4.4'
      // uiVersion: '1.1', // ui库版本，不配置不加载,
      // v: '2.0'
    });

    window._AMapSecurityConfig = {
      securityJsCode: securityJsCode
    }
  }
}

// 谷歌地图 Key:AIzaSyCOJhbwEP0_CGZr9JDHLBTEWK8YrQFs610
import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCOJhbwEP0_CGZr9JDHLBTEWK8YrQFs610',
    libraries: 'places'
  }
})

Vue.prototype.$markerIcon =
  'https://sgy.douhuomall.com/uploads/image/20201101/2a4dca66fa94fa2d06bf6c93728d0bcd.png'; // 地图点图标

// AIzaSyCOJhbwEP0_CGZr9JDHLBTEWK8YrQFs610 泰国谷歌地图key



// WEBPACK FOOTER //
// ./src/map.js